// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* this class must contain "see-inside-button" somewhere for the s3 dev tools to be able to reinject itself */

/* https://github.com/griffpatch/Scratch3-Dev-Tools/blob/0.2.4/inject3.js#L1804-L1807 */

.tw-see-inside_see-inside-button_Z9EyT {
    box-shadow: 0 0 0 1px var(--ui-black-transparent);
}

.tw-see-inside_see-inside-button-icon_u04Bq {
    height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/tw-see-inside.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,6GAA6G;;AAE7G,uFAAuF;;AAEvF;IACI,iDAAiD;AACrD;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* this class must contain \"see-inside-button\" somewhere for the s3 dev tools to be able to reinject itself */\n\n/* https://github.com/griffpatch/Scratch3-Dev-Tools/blob/0.2.4/inject3.js#L1804-L1807 */\n\n.see-inside-button {\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\n}\n\n.see-inside-button-icon {\n    height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `tw-see-inside_see-inside-button_Z9EyT`;
export { _1 as "see-inside-button" };
export var seeInsideButton = `tw-see-inside_see-inside-button_Z9EyT`;
var _2 = `tw-see-inside_see-inside-button-icon_u04Bq`;
export { _2 as "see-inside-button-icon" };
export var seeInsideButtonIcon = `tw-see-inside_see-inside-button-icon_u04Bq`;
export default ___CSS_LOADER_EXPORT___;
